import {
  AfterViewInit,
  Compiler,
  Component,
  EventEmitter,
  Injector,
  Input,
  NgModuleFactory,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Observable } from 'rxjs';
import { DevExGridComponent } from '../../../devExtreme/src/devExGrid/devExGrid.component';
import { MatGridComponent } from '../../../material/src/matGrid/matGrid.component';
import { ComponentStyle, IAbcComponent } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { AbcContextMenu } from '../abcContextMenu/abcContextMenu';
import {
  ColumnHeader,
  EditingMode,
  GridStyle,
  IGrid,
  Mode,
  RowMode,
  ScrollMode,
  ShowMode,
  SortingMode,
  toolbarItems,
} from './abcGrid';

@Component({
  selector: 'abcGrid',
  template: '<ng-template #abcGrid></ng-template>',
})
export class AbcGridComponent implements IAbcComponent, OnInit, AfterViewInit, OnDestroy {
  @ViewChild('abcGrid', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  private _columnsHeader: ColumnHeader[];
  private _gridData: any[];
  private _toolbarItems: toolbarItems[];
  private _width: string;
  private _height: string;
  private _showRowLines: boolean;
  private _filterSyncEnabled: boolean;
  private _showAddFloatingActionButton: boolean;
  private _dropDownBoxHeight: string | number;
  private _allowSaveEditDataOnDDBoxClosed: boolean;
  private _allowDDBoxAutoOpen: boolean;
  private _showDetails: boolean;
  private _showColumnLines: boolean;
  private _showColumnHeaders: boolean;
  private _class: string;
  private _allowColumnReordering: boolean;
  private _showfilterrow: boolean;
  private _allowColumnResizing: boolean;
  private _rowAlternationEnabled: boolean;
  private _hoverStateEnabled: boolean;
  private _enableColumnFixing: boolean;

  private _showBorders: boolean;
  private _columnHidingEnabled: boolean;
  private _columnAutoWidth: boolean;
  private _disabled: boolean;
  private _visible: boolean = true;
  private _enablePaging: boolean;
  private _searchPanel: boolean;
  private _placeholder: string;
  private _widthSearch: string;
  private _highlightSearchText: boolean;
  private _text: string;
  private _allowSelectAll: boolean;
  private _selectionMode: Mode;
  private _showCheckBoxesMode: ShowMode;
  private _filterPanel: boolean;
  private _scrolleMode: ScrollMode;
  private _rowRenderingMode: RowMode;
  private _autoExpandAll: boolean;
  private _rtlEnabled: boolean;
  private _groupable: boolean;
  private _id: string;
  private _style: ComponentStyle;
  private _stateStorageKey: string;
  private _filterKey: Array<string>;
  private _showDropDownFilterRow: boolean;
  private _showDropDownColumnHeaders: boolean = true;
  private _allowAdding: boolean;
  private _selectedRowKey: string;
  private _allowReordering: boolean;
  @Input() showClearBtn: boolean;
  @Input()
  public get showDropDownFilterRow(): boolean {
    return this._showDropDownFilterRow;
  }
  public set showDropDownFilterRow(value: boolean) {
    if (this.componentRef) {
      this.componentRef.showDropDownFilterRow = value;
    }
    this._showDropDownFilterRow = value;
  }

  @Input()
  public get showDropDownColumnHeaders(): boolean {
    return this._showDropDownColumnHeaders;
  }
  public set showDropDownColumnHeaders(value: boolean) {
    if (this.componentRef) {
      this.componentRef.showDropDownColumnHeaders = value;
    }
    this._showDropDownColumnHeaders = value;
  }

  @Input()
  get style() {
    return this._style;
  }
  set style(data: ComponentStyle) {
    this._style = data;

    if (this.componentRef) {
      this.viewContainerRef.clear();
      this.createComponentInstance().subscribe((component) => {
        this.eventListener.forEach((element) => {
          component.addEventListener(element.type, element.listener);
        });
      });
    }
  }

  @Input('gridData')
  get gridData() {
    return this._gridData;
  }
  set gridData(data) {
    if (this.componentRef) {
      this.componentRef.gridData = data;
    }
    this._gridData = data;
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data: string) {
    this._width = data;
    if (this.componentRef) {
      this.componentRef.width = data;
    }
  }

  @Input()
  get height() {
    return this._height;
  }
  set height(data: string) {
    this._height = data;
    if (this.componentRef) {
      this.componentRef.height = data;
    }
  }

  @Input()
  get showRowLines() {
    return this._showRowLines;
  }
  set showRowLines(data: boolean) {
    this._showRowLines = data;
    if (this.componentRef) {
      this.componentRef.showRowLines = data;
    }
  }

  @Input()
  get filterSyncEnabled() {
    return this._filterSyncEnabled;
  }
  set filterSyncEnabled(data: boolean) {
    this._filterSyncEnabled = data;
    if (this.componentRef) {
      this.componentRef.filterSyncEnabled = data;
    }
  }

  @Input()
  get showAddFloatingActionButton() {
    return this._showAddFloatingActionButton;
  }
  set showAddFloatingActionButton(data: boolean) {
    this._showAddFloatingActionButton = data;
    if (this.componentRef) {
      this.componentRef.showAddFloatingActionButton = data;
    }
  }

  @Input()
  get dropDownBoxHeight() {
    return this._dropDownBoxHeight;
  }
  set dropDownBoxHeight(data: string | number) {
    this._dropDownBoxHeight = data;
    if (this.componentRef) {
      this.componentRef.dropDownBoxHeight = data;
    }
  }

  @Input()
  get allowSaveEditDataOnDDBoxClosed() {
    return this._allowSaveEditDataOnDDBoxClosed;
  }
  set allowSaveEditDataOnDDBoxClosed(data: boolean) {
    this._allowSaveEditDataOnDDBoxClosed = data;
    if (this.componentRef) {
      this.componentRef.allowSaveEditDataOnDDBoxClosed = data;
    }
  }

  @Input()
  get allowDDBoxAutoOpen() {
    return this._allowDDBoxAutoOpen;
  }
  set allowDDBoxAutoOpen(data: boolean) {
    this._allowDDBoxAutoOpen = data;
    if (this.componentRef) {
      this.componentRef.allowDDBoxAutoOpen = data;
    }
  }

  @Input()
  get toolbarItems(): toolbarItems[] {
    return this._toolbarItems;
  }
  set toolbarItems(data: toolbarItems[]) {
    this._toolbarItems = data;
    if (this.componentRef) {
      this.componentRef.toolbarItems = data;
    }
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data: boolean) {
    this._rtlEnabled = data;
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
  }

  @Input()
  get showDetails() {
    return this._showDetails;
  }
  set showDetails(data: boolean) {
    this._showDetails = data;
    if (this.componentRef) {
      this.componentRef.showDetails = data;
    }
  }

  @Input()
  get showColumnLines() {
    return this._showColumnLines;
  }
  set showColumnLines(data: boolean) {
    this._showColumnLines = data;
    if (this.componentRef) {
      this.componentRef.showColumnLines = data;
    }
  }

  @Input()
  get showColumnHeaders() {
    return this._showColumnHeaders;
  }
  set showColumnHeaders(data: boolean) {
    this._showColumnHeaders = data;
    if (this.componentRef) {
      this.componentRef.showColumnHeaders = data;
    }
  }

  @Input()
  get class(): string {
    return this._class;
  }
  set class(val: string) {
    this._class = val;

    if (this.componentRef) {
      this.componentRef.class = val;
    }
  }

  @Input()
  get allowColumnReordering() {
    return this._allowColumnReordering;
  }
  set allowColumnReordering(data: boolean) {
    this._allowColumnReordering = data;
    if (this.componentRef) {
      this.componentRef.allowColumnReordering = data;
    }
  }

  @Input()
  get showfilterrow() {
    return this._showfilterrow;
  }
  set showfilterrow(data: boolean) {
    this._showfilterrow = data;
    if (this.componentRef) {
      this.componentRef.showfilterrow = data;
    }
  }

  @Input()
  get allowColumnResizing() {
    return this._allowColumnResizing;
  }
  set allowColumnResizing(data: boolean) {
    this._allowColumnResizing = data;
    if (this.componentRef) {
      this.componentRef.allowColumnResizing = data;
    }
  }

  @Input()
  get rowAlternationEnabled() {
    return this._rowAlternationEnabled;
  }
  set rowAlternationEnabled(data: boolean) {
    this._rowAlternationEnabled = data;
    if (this.componentRef) {
      this.componentRef.rowAlternationEnabled = data;
    }
  }

  @Input()
  get enableColumnFixing() {
    return this._enableColumnFixing;
  }
  set enableColumnFixing(data: boolean) {
    this._enableColumnFixing = data;
    if (this.componentRef) {
      this.componentRef.enableColumnFixing = data;
    }
  }

  @Input()
  get hoverStateEnabled() {
    return (this._hoverStateEnabled = true);
  }
  set hoverStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = data;
    }
    this._hoverStateEnabled = data;
  }

  @Input()
  get showBorders() {
    return this._showBorders;
  }
  set showBorders(data) {
    if (this.componentRef) {
      this.componentRef.showBorders = data;
    }
    this._showBorders = data;
  }

  @Input()
  get columnHidingEnabled() {
    return this._columnHidingEnabled;
  }
  set columnHidingEnabled(data) {
    if (this.componentRef) {
      this.componentRef.columnHidingEnabled = data;
    }
    this._columnHidingEnabled = data;
  }

  @Input()
  get columnAutoWidth() {
    return this._columnAutoWidth;
  }
  set columnAutoWidth(data) {
    if (this.componentRef) {
      this.componentRef.columnAutoWidth = data;
    }
    this._columnAutoWidth = data;
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data) {
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
    this._disabled = data;
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data) {
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
    this._visible = data;
  }

  @Input()
  get enablePaging() {
    return this._enablePaging;
  }
  set enablePaging(data) {
    if (this.componentRef) {
      this.componentRef.enablePaging = data;
    }
    this._enablePaging = data;
  }

  @Input()
  get searchPanel() {
    return this._searchPanel;
  }
  set searchPanel(data) {
    if (this.componentRef) {
      this.componentRef.searchPanel = data;
    }
    this._searchPanel = data;
  }

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(data) {
    if (this.componentRef) {
      this.componentRef.placeholder = data;
    }
    this._placeholder = data;
  }

  @Input()
  get text() {
    return this._text;
  }
  set text(data) {
    if (this.componentRef) {
      this.componentRef.text = data;
    }
    this._text = data;
  }

  @Input()
  get widthSearch() {
    return this._widthSearch;
  }
  set widthSearch(data) {
    if (this.componentRef) {
      this.componentRef.widthSearch = data;
    }
    this._widthSearch = data;
  }

  @Input()
  get highlightSearchText() {
    return this._highlightSearchText;
  }
  set highlightSearchText(data) {
    if (this.componentRef) {
      this.componentRef.highlightSearchText = data;
    }
    this._highlightSearchText = data;
  }

  @Input()
  get allowSelectAll() {
    return this._allowSelectAll;
  }
  set allowSelectAll(data) {
    if (this.componentRef) {
      this.componentRef.allowSelectAll = data;
    }
    this._allowSelectAll = data;
  }

  @Input()
  get selectionMode() {
    return this._selectionMode;
  }
  set selectionMode(data) {
    if (this.componentRef) {
      this.componentRef.selectionMode = data;
    }
    this._selectionMode = data;
  }

  @Input()
  get showCheckBoxesMode() {
    return this._showCheckBoxesMode;
  }
  set showCheckBoxesMode(data) {
    if (this.componentRef) {
      this.componentRef.showCheckBoxesMode = data;
    }
    this._showCheckBoxesMode = data;
  }

  @Input()
  get filterPanel() {
    return this._filterPanel;
  }
  set filterPanel(data) {
    if (this.componentRef) {
      this.componentRef.filterPanel = data;
    }
    this._filterPanel = data;
  }

  @Input()
  get filterKey() {
    return this._filterKey;
  }
  set filterKey(data) {
    if (this.componentRef) {
      this.componentRef.filterKey = data;
    }
    this._filterKey = data;
  }

  @Input()
  get scrolleMode() {
    return this._scrolleMode;
  }
  set scrolleMode(data) {
    if (this.componentRef) {
      this.componentRef.scrolleMode = data;
    }
    this._scrolleMode = data;
  }

  @Input()
  get rowRenderingMode() {
    return this._rowRenderingMode;
  }
  set rowRenderingMode(data) {
    if (this.componentRef) {
      this.componentRef.rowRenderingMode = data;
    }
    this._rowRenderingMode = data;
  }

  @Input()
  get autoExpandAll() {
    return this._autoExpandAll;
  }
  set autoExpandAll(data) {
    if (this.componentRef) {
      this.componentRef.autoExpandAll = data;
    }
    this._autoExpandAll = data;
  }

  @Input()
  get groupable() {
    return this._groupable;
  }
  set groupable(data) {
    if (this.componentRef) {
      this.componentRef.groupable = data;
    }
    this._groupable = data;
  }

  @Input('columnsHeader')
  get columnsHeader(): ColumnHeader[] {
    return this._columnsHeader;
  }
  set columnsHeader(colsHeader: ColumnHeader[]) {
    this._columnsHeader = colsHeader;
    if (this.componentRef && this.style === ComponentStyle.DevExpress) this.componentRef.columns = colsHeader;
  }

  @Input()
  get stateStorageKey(): string {
    return this._stateStorageKey;
  }
  set stateStorageKey(stateKey) {
    if (this.componentRef) {
      this.componentRef.stateStorageKey = stateKey;
    }
    this._stateStorageKey = stateKey;
  }

  @Input()
  get id(): string {
    return this._id;
  }
  set id(value) {
    this._id = value;
  }

  @Input() get allowAdding(): boolean {
    return this._allowAdding;
  }

  set allowAdding(val: boolean) {
    if (this.componentRef) {
      this.componentRef.allowAdding = val;
    }
    this._allowAdding = val;
  }

  @Input()
  get selectedRowKey(): string {
    return this._selectedRowKey;
  }
  set selectedRowKey(val: string) {
    this._selectedRowKey = val;
  }

  @Input() get allowReordering(): boolean {
    return this._allowReordering;
  }

  set allowReordering(val: boolean) {
    if (this.componentRef) {
      this.componentRef.allowReordering = val;
    }
    this._allowReordering = val;
  }

  @Input('rowsheight') rowsheight: number;
  @Input('filterable') filterable: boolean;
  @Input('rendertoolbar') rendertoolbar;
  @Input('showdefaultloadelement') showdefaultloadelement: boolean;
  @Input('autoshowloadelement') autoshowloadelement: boolean;
  @Input('sortable') sortable: boolean;
  @Input('showsortmenuitems') showsortmenuitems: boolean;
  @Input('columnsresize') columnsresize: boolean;
  @Input('columnsmenu') columnsmenu: boolean;
  @Input('showtoolbar') showtoolbar: boolean;
  @Input('enabletooltips') enabletooltips: boolean;
  @Input('autoshowcolumnsmenubutton') autoshowcolumnsmenubutton: boolean;
  @Input('showemptyrow') showemptyrow: boolean;
  @Input('enableellipsis') enableellipsis: boolean;
  @Input('columnsreorder') columnsreorder: boolean;
  @Input('pageable') pageable: boolean;
  @Input('autoshowfiltericon') autoshowfiltericon: boolean;
  @Input('editmode') editmode: string;
  @Input('editable') editable: boolean;
  @Input('exprotButton') exportButton: boolean;
  @Input('selectedrow') selectedrow: boolean;
  @Input('virtualmode') virtualmode: boolean;
  @Input('autorowheight') autorowheight: boolean;
  @Input('remoteOperations') remoteOperations: boolean;
  @Input('allowUpdating') allowUpdating: boolean;
  @Input('rowFilter') rowFilter: boolean;
  @Input('columnFilter') columnFilter: boolean;
  @Input('keyExpr') keyExpr: string;
  @Input('allowedPageSizes') allowedPageSizes: string;
  @Input('useNative') useNative: boolean;
  @Input('allowDeleting') allowDeleting: boolean = false;
  @Input('useIcons') useIcons: boolean = true;
  @Input('confirmDelete') confirmDelete: boolean = true;
  @Input('showDragIcons') showDragIcons: boolean = false;
  @Input('popUpTitle') popUpTitle: string = 'Edit';
  @Input('showTitle') showTitle: boolean = true;
  @Input('popUpWidth') popUpWidth: string | number;
  @Input('popUpHeight') popUpHeight: string | number;
  @Input('editingMode') editingMode: EditingMode;
  @Input('sortingMode') sortingMode: SortingMode = SortingMode.Multiple;
  @Input() enableStateStorage: boolean;
  @Input() contextMenuOptions: AbcContextMenu[];
  @Input() dropDownDataSource: any;
  @Input() allowColumnChooserSearch: boolean;
  @Input() columnChooserSortOrder: 'asc' | 'desc';
  @Output() onRowSelect = new EventEmitter();
  @Output() onSelectionChanged = new EventEmitter();
  @Output() onBindingcomplete = new EventEmitter();
  @Output() onCellEndEdit = new EventEmitter();
  @Output() onCellValueChanged = new EventEmitter();
  @Output() onCellBeginEdit = new EventEmitter();
  @Output() onRowunselect = new EventEmitter();
  @Output() onRowDoubleClick = new EventEmitter();
  @Output() onCellPrepared = new EventEmitter();
  @Output() onContentReady = new EventEmitter();
  @Output() onInitialized = new EventEmitter();
  @Output() onContextMenuPreparing = new EventEmitter();
  @Output() onInitNewRow: EventEmitter<any> = new EventEmitter();
  @Output() onRowInserted = new EventEmitter();
  @Output() onRowInserting = new EventEmitter();
  @Output() onEditingStart = new EventEmitter();
  @Output() onRowUpdated = new EventEmitter();
  @Output() onRowUpdating = new EventEmitter();
  @Output() onValueChanged = new EventEmitter();
  @Output() onColumnUpdate = new EventEmitter();
  @Output() onColumnSorting = new EventEmitter();
  @Output() onSortRemoving = new EventEmitter();
  @Output() onGridScrolling = new EventEmitter();
  @Output() onEditorPrepared = new EventEmitter();
  @Output() onRowRemoved = new EventEmitter();
  @Output() onFocusedCellChanged = new EventEmitter();
  @Output() onEditorPreparing = new EventEmitter();
  @Output() onToolbarPreparing = new EventEmitter();
  @Output() onRowValidating = new EventEmitter();
  @Output() onCellClick = new EventEmitter();
  @Output() onOpened = new EventEmitter();
  @Output() onSaveColumns = new EventEmitter();

  // @Input() style: ComponentStyle = ComponentStyle.DevExpress;
  GridStyle: GridStyle;
  public htmlAttributes: IGrid;
  private _componentRef;
  public get componentRef() {
    return this._componentRef;
  }
  public set componentRef(value) {
    this._componentRef = value;
  }
  private eventListener = [];
  private devxGrid: DevExGridComponent;

  constructor(
    private abcComponentService: AbcComponentService,
    private compiler: Compiler,
    private injector: Injector
  ) {
    this.style = ComponentStyle.Material;
    this.rtlEnabled = this.abcComponentService.rtlEnabled;
  }

  ngOnInit() {
    this.setGridsAttributesIfAvailable();
    this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit() {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.abcComponentService.removeInstance(this);
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.Material: {
          this.componentRef = this.abcComponentService.loadComponent(
            MatGridComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.setAttributes(this.componentRef);
          observer.next(this.componentRef);
          break;
        }
        case ComponentStyle.DevExpress: {
          import('../../../devExtreme/src/devExGrid/devExGrid.module').then((a) => {
            this.compiler
              .compileModuleAsync(a.DevExGridModule)

              .then((moduleFactory: NgModuleFactory<any>) => {
                const moduleRef = moduleFactory.create(this.injector);
                const componentFactory = moduleRef.instance.resolveComponent();
                this.componentRef = this.abcComponentService.loadComponent(
                  componentFactory.componentType,
                  this.viewContainerRef
                ).componentRef.instance;

                this.componentRef.dropDownDataSource = this.dropDownDataSource;
                this.componentRef.columns = this.htmlAttributes.columnsHeader;

                this.componentRef.onCellPrepared.subscribe((event) => {
                  this.cellPrepared(event);
                });

                this.componentRef.onRowDblClick.subscribe((event) => {
                  this.rowDoubleClick(event);
                });

                this.componentRef.onContentReady.subscribe((event) => {
                  this.contentReady(event);
                });

                this.componentRef.onInitialized.subscribe((event) => {
                  this._onInitilized(event);
                });

                this.componentRef.onSelectionChanged.subscribe((event) => {
                  this.rowSelect(event.event, event.rowId);
                });
                this.componentRef.onSelectChanged.subscribe((event) => {
                  this.selectChanged(event);
                });

                this.componentRef.onContextMenuPreparing.subscribe((event) => {
                  this.contextMenuPreparing(event);
                });

                this.componentRef.onInitNewRow.subscribe((event) => {
                  this.initNewRow(event);
                });

                this.componentRef.onRowInserted.subscribe((event) => {
                  this.rowInserted(event);
                });

                this.componentRef.onRowInserting.subscribe((event) => {
                  this.rowInserting(event);
                });

                this.componentRef.onEditingStart.subscribe((event) => {
                  this.editingStart(event);
                });

                this.componentRef.onRowUpdated.subscribe((event) => {
                  this.rowUpdated(event);
                });

                this.componentRef.onRowUpdating.subscribe((event) => {
                  this.rowUpdating(event);
                });

                this.componentRef.onValueChanged.subscribe((event) => {
                  this.valueChanged(event);
                });

                this.componentRef.onColumnUpdate.subscribe((event) => {
                  this.ColumnUpdate(event);
                });

                this.componentRef.onColumnSorting.subscribe((event) => {
                  this.ColumnSorting(event);
                });
                this.componentRef.onGridScrolling.subscribe((scrollPosition) => {
                  this.gridScrolling(scrollPosition);
                });
                this.componentRef.onRowRemoved.subscribe((event) => {
                  this.rowRemoved(event);
                });
                this.componentRef.onFocusedCellChanged.subscribe((event) => {
                  this.focusedCellChanged(event);
                });
                this.componentRef.onEditorPreparing.subscribe((e) => {
                  this.onEditorPreparing.emit(e);
                });
                this.componentRef.onToolbarPreparing.subscribe((event) => {
                  this.toolbarPreparing(event);
                });
                this.componentRef.onRowValidating.subscribe((event) => {
                  this.rowValidating(event);
                });
                this.componentRef.onCellClick.subscribe((event) => {
                  this.cellClick(event);
                });

                this.componentRef.onOpened.subscribe((event) => {
                  this.dropDownOpened(event);
                });
                this.componentRef.onSaveColumns.subscribe((event) => {
                  this.saveColumns(event);
                });
                this.devxGrid = this.componentRef;
                this.setAttributes(this.componentRef);
                observer.next(this.componentRef);
              });
          });
          break;
        }
      }
    });
    return observable;
  }

  private setAttributes(componentRef) {
    this.componentRef.rtlEnabled = this.rtlEnabled ? this.rtlEnabled : false;
    if (this.htmlAttributes.id) componentRef.id = this.htmlAttributes.id;
    if (this.htmlAttributes.columnsHeader) componentRef.columnsHeader = this.htmlAttributes.columnsHeader;
    if (this.htmlAttributes.gridData) componentRef.gridData = this.htmlAttributes.gridData;
    if (this.htmlAttributes.class) componentRef.class = this.htmlAttributes.class;
    if (this.htmlAttributes.contextMenuOptions)
      componentRef.contextMenuOptions = this.htmlAttributes.contextMenuOptions;
    if (this.componentRef.setGridStyle) componentRef.setGridStyle(this.htmlAttributes.setGridStyle());
  }

  private setGridsAttributesIfAvailable(): void {
    if (this.id) {
      const style: GridStyle = {
        width: this.width ? this.width : '100%',
        height: this.height ? this.height : '100%',
        showfilterrow: this.showfilterrow,
        showBorders: this.showBorders,
        showClearBtn: this.showClearBtn,
        columnHidingEnabled: this.columnHidingEnabled,
        hoverStateEnabled: (this.hoverStateEnabled = true),
        allowColumnResizing: this.allowColumnResizing,
        rowAlternationEnabled: this.rowAlternationEnabled,
        filterable: this.filterable,
        showdefaultloadelement: this.showdefaultloadelement,
        groupable: this.groupable,
        enableStateStorage: this.enableStateStorage,
        autoshowloadelement: this.autoshowloadelement,
        sortable: this.sortable,
        showsortmenuitems: this.showsortmenuitems,
        columnsresize: this.columnsresize,
        columnsmenu: this.columnsmenu,
        enabletooltips: this.enabletooltips,
        enableColumnFixing: this.enableColumnFixing ? this.enableColumnFixing : false,
        autoshowcolumnsmenubutton: this.autoshowcolumnsmenubutton,
        showemptyrow: this.showemptyrow,
        enableellipsis: this.enableellipsis,
        columnsreorder: this.columnsreorder,
        pageable: this.pageable,
        autoshowfiltericon: this.autoshowfiltericon,
        showDetails: this.showDetails,
        allowColumnReordering: this.allowColumnReordering,
        allowColumnChooserSearch: this.allowColumnChooserSearch,
        columnChooserSortOrder: this.columnChooserSortOrder,
        showRowLines: this.showRowLines,
        filterSyncEnabled: this.filterSyncEnabled,
        showAddFloatingActionButton: this.showAddFloatingActionButton,
        dropDownBoxHeight: this.dropDownBoxHeight,
        allowSaveEditDataOnDDBoxClosed: this.allowSaveEditDataOnDDBoxClosed,
        allowDDBoxAutoOpen: this.allowDDBoxAutoOpen,
        showColumnHeaders: this.showColumnHeaders,
        showColumnLines: this.showColumnLines,
        rendertoolbar: this.rendertoolbar,
        showtoolbar: this.showtoolbar,
        editable: this.editable,
        allowAdding: this.allowAdding,
        allowReordering: this.allowReordering,
        editmode: this.editmode,
        selectedrow: this.selectedrow,
        virtualmode: this.virtualmode,
        autorowheight: this.autorowheight,
        columnFilter: this.columnFilter,
        stateStorageKey: this.stateStorageKey,
        exportButton: this.exportButton,
        keyExpr: this.keyExpr,
        allowDeleting: this.allowDeleting,
        useIcons: this.useIcons,
        confirmDelete: this.confirmDelete,
        showDragIcons: this.showDragIcons,
        popUpTitle: this.popUpTitle,
        showTitle: this.showTitle,
        popUpWidth: this.popUpWidth,
        popUpHeight: this.popUpHeight,
        editingMode: this.editingMode,
        sortingMode: this.sortingMode,
        columnAutoWidth: this.columnAutoWidth,
        disabled: this.disabled,
        visible: (this.visible = true),
        enablePaging: this.enablePaging,
        autoExpandAll: this.autoExpandAll,
        searchPanel: this.searchPanel,
        placeholder: this.placeholder,
        text: this.text,
        widthSearch: this.widthSearch,
        highlightSearchText: this.highlightSearchText,
        selectionMode: this.selectionMode,
        allowSelectAll: this.allowSelectAll,
        filterPanel: this.filterPanel,
        filterKey: this.filterKey,
        scrolleMode: this.scrolleMode,
        rowRenderingMode: this.rowRenderingMode,
        useNative: this.useNative,
        toolbarItems: this.toolbarItems,
        rtlEnabled: this.rtlEnabled ? this.rtlEnabled : false,
        allowUpdating: this.allowUpdating,
        showDropDownColumnHeaders: this.showDropDownColumnHeaders,
        selectedRowKey: this.selectedRowKey,
      };
      this.htmlAttributes = {
        columnsHeader: this.columnsHeader,
        gridData: this.gridData,
        contextMenuOptions: this.contextMenuOptions,
        id: this.id,
        class: this.class,
        setGridStyle: (_gridStyle) => (_gridStyle = style),
      };
    }
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ): void {
    this.eventListener.push({ type, listener });
  }

  public updateABCGridInstance(source, columns?): void {
    if (this.style === ComponentStyle.DevExpress) {
      this.componentRef.columns = columns;
      this.componentRef.gridData = source;
    }
  }

  public updateSummary(totalCountEnabled: boolean) {
    this.componentRef.updateSummary(totalCountEnabled);
  }

  public updateData(source, columnsHeader?): void {
    if (this.style === ComponentStyle.DevExpress) {
      this.componentRef?.updateDataGrid(source, columnsHeader);
    }
  }

  public updateDataDetailsGrid(data) {
    this.componentRef.updateDataDetailsGrid(data);
  }

  public valueChanged(e) {
    this.onValueChanged.emit(e);
  }

  public selectRow(indexes: string): void {
    this.componentRef.selectRows(indexes);
    this.componentRef.focusedRowKey = indexes;
  }

  public getSelectedRowsData() {
    this.componentRef.getSelectedRowsData();
  }

  public rowDoubleClick(event: any): void {
    this.onRowDoubleClick.emit({ event: event });
  }

  public rowSelect(event, rowId: string): void {
    this.onRowSelect.emit({ event: event, rowId: rowId });
  }
  public selectionChanged(event): void {
    this.onRowSelect.emit(event);
  }
  public selectChanged(event): void {
    this.onSelectionChanged.emit(event);
  }
  public cellPrepared(event): void {
    this.onCellPrepared.emit(event);
  }

  public contentReady(event): void {
    this.onContentReady.emit(event);
  }

  public _onInitilized(event): void {
    this.onInitialized.emit(event);
  }

  public cellEndEdit(event): void {
    this.onCellEndEdit.emit({ event: event });
  }
  public cellValueChanged(event): void {
    this.onCellValueChanged.emit({ event: event });
  }

  public initNewRow(event): void {
    this.onInitNewRow.emit(event);
  }
  public rowInserting(event): void {
    this.onRowInserting.emit(event);
  }

  public rowInserted(event): void {
    this.onRowInserted.emit(event);
  }

  public editingStart(event): void {
    this.onEditingStart.emit(event);
  }

  public rowUpdating(event): void {
    this.onRowUpdating.emit(event);
  }

  public rowUpdated(event): void {
    this.onRowUpdated.emit(event);
  }

  public cellBeginEdit(event): void {
    this.onCellBeginEdit.emit({ event: event });
  }

  public rowUnselect(event): void {
    this.onRowunselect.emit({ event: event });
  }

  public bindingComplete(event): void {
    this.onBindingcomplete.emit({ event: event });
  }

  public toolbarPreparing(event): void {
    this.onToolbarPreparing.emit(event);
  }
  public rowValidating(event) {
    this.onRowValidating.emit(event);
  }

  public cellClick(event) {
    this.onCellClick.emit(event);
  }

  public dropDownOpened(event) {
    this.onOpened.emit(event);
  }

  public filter(id) {
    return this.componentRef.filter(id);
  }

  public clearFilter() {
    return this.componentRef.clearFilter();
  }

  public getRowData(index) {
    return this.componentRef.getRowData(index);
  }

  public getselectedrowindex() {
    return this.componentRef.getselectedrowindex();
  }

  public getSelectedRowData() {
    return this.componentRef.getSelectedRowData();
  }

  public addEmptyRow(rowPosition?): void {
    this.componentRef.addEmptyRow(rowPosition);
  }

  public setGridOptions(option: string, optionValue: any): void {
    this.componentRef.setGridOptions(option, optionValue);
  }

  public deleteSelectedRow(): void {
    this.componentRef.deleteSelectedRow();
  }

  public refresh() {
    if (this.style === ComponentStyle.DevExpress) {
      this.devxGrid.refresh();
    }
  }

  public removeSort(): void {
    this.componentRef.removeSort();
    this.onSortRemoving.emit(event);
  }

  public toggleText(): void {
    this.componentRef.toggleText();
  }
  public copyColumnDataToClipBoard(columnDataField: string) {
    return this.componentRef.copyColumnDataToClipBoard(columnDataField);
  }

  public pasteDataFromClipBoard(columnHeaderName: string, data: string | Array<any>, columnHeaderIndex?: number): void {
    this.componentRef.pasteDataFromClipBoard(columnHeaderName, data, columnHeaderIndex);
  }

  public updateDataGrid(data): void {
    this.devxGrid.updateDataGrid(data);
  }

  public contextMenuPreparing(event): void {
    this.onContextMenuPreparing.emit(event);
  }

  public openColumnChooser(): void {
    this.componentRef.openColumnChooser();
  }

  public exportGridData(): void {
    this.componentRef.exportGridData();
  }
  public showColumnChooser(): void {
    this.componentRef.showColumnChooser();
  }

  public hideColumnChooser(): void {
    this.componentRef.closeColumnChooser();
  }

  public ColumnUpdate(event) {
    this.onColumnUpdate.emit(event);
  }
  public ColumnSorting(event) {
    this.onColumnSorting.emit(event);
  }

  public gridScrolling(e) {
    this.onGridScrolling.emit(e);
  }

  public rowRemoved(event): void {
    this.onRowRemoved.emit(event);
  }

  public scrollTo(scrollPosition: number): void {
    this.componentRef.scrollTo(scrollPosition);
  }

  public setDropdownBoxes(box: any): void {
    this.componentRef.setDropdownBoxes(box);
  }
  public updateColumnsHeader(columnHeader: ColumnHeader[]): void {
    this.componentRef.updateColumnsHeader(columnHeader);
  }

  public checkForDefaultDDBoxFilter(box: any): void {
    this.componentRef.checkForDefaultDDBoxFilter(box);
  }

  public focusedCellChanged(event): void {
    this.onFocusedCellChanged.emit(event);
  }

  public getRowIndexByKey(key: string): number {
    return this.componentRef?.getRowIndexByKey(key) ?? 0;
  }

  public saveColumns(event): void {
    this.onSaveColumns.emit(event);
  }

  public getFilteredObjects() {
    return this.componentRef?.getFilteredObjects();
  }
}
